import {
  MotifButton,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from "@ey-xd/motif-react";
import { getCostInterval } from "../../OrderExtensionHelper";
import "./ViewDetails.scss";
import { COST_MACRO_CATEGORY } from "../../../../Constant";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { fetchSkuConfigData } from "../../../../store/slices/CTDBSkuConfigSlice";
import Loader from "../../../../components/Loader";

export function ViewDetails({ viewDetailsData }: any) {
  const {
    isViewDetailsOpen,
    skuId,
    skuName,
    skuDescription,
    skuStatusName,
    skuCost,
    returnable,
    skuCostInterval,
    setIsViewDetailsOpen,
    skuCostMacroCategoryCd,
    CostMetricCd,
    skuCostMetricNSR,
    skuIndexation,
  } = viewDetailsData;

  const dispatch = useDispatch<AppDispatch>();

  // Function to close the view details modal
  const handleCloseViewDetails = () => {
    setIsViewDetailsOpen(false);
    document.body.style.overflow = "";
  };

  const configData = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.data,
  );

  if (configData === null || configData === undefined) {
    dispatch(fetchSkuConfigData());
  }

  if (!configData) {
    return <Loader />;
  }

  // finding the mapping details for cost metric and cost type and macro category
  let macroCategory = "";
  if (configData?.CostMacroCategory) {
    macroCategory =
      (configData?.CostMacroCategory ?? [])
        .filter((item) =>
          skuCostMacroCategoryCd?.includes(item.CostMacroCategoryCd),
        )
        .map((item) => item.Name)
        .join(", ") || "";
  }

  const costType =
    configData?.CostCategory.find((item) => item.CostMetricCd === CostMetricCd)
      ?.CostMetricType || "";
  const costMetric =
    configData?.CostCategory.find((item) => item.CostMetricCd === CostMetricCd)
      ?.CostMetric || "";

  return (
    <MotifModal
      show={isViewDetailsOpen}
      onClose={handleCloseViewDetails}
      className="checkout-detail-view-details"
      size="lg"
      variant="slideout"
    >
      <MotifModalHeader>View Details</MotifModalHeader>
      <MotifModalBody>
        <section>
          <h4 className="view-details-name">{skuName}</h4>
          <p className="view-details-id">{skuId}</p>
          <div className="section-divider"></div>
        </section>
        <section>
          <h4 className="view-details-description-header">Description</h4>
          <p className="view-details-description">
            <div
              className="ql-editor no-padding"
              dangerouslySetInnerHTML={
                skuDescription
                  ? { __html: skuDescription.replace(/&nbsp;/g, " ") }
                  : undefined
              }
            ></div>
          </p>
          <div className="section-divider"></div>
        </section>
        <section>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">Status</h4>
            <p className="view-details-common-value">{skuStatusName}</p>
          </div>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">Cost</h4>
            <p className="view-details-common-value">
              {skuCost.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              })}
            </p>
          </div>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">Returnable</h4>
            <p className="view-details-common-value text-capitalize">
              {returnable ? "Yes" : "No"}
            </p>
          </div>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">Cost Interval</h4>
            <p className="view-details-common-value">
              {getCostInterval(skuCostInterval)}
            </p>
          </div>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">Cost Type</h4>
            <p className="view-details-common-value">{costType}</p>
          </div>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">Cost Metric</h4>
            <p className="view-details-common-value">{costMetric}</p>
          </div>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">
              {COST_MACRO_CATEGORY}
            </h4>
            <p className="view-details-common-value">{macroCategory}</p>
          </div>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">NSR</h4>
            <p className="view-details-common-value">
              {skuCostMetricNSR ? `$${skuCostMetricNSR}` : "-"}
            </p>
          </div>
          <div className="view-details-common-content">
            <h4 className="view-details-common-header">Indexation</h4>
            <p className="view-details-common-value">
              {skuIndexation ? `${skuIndexation}` : "-"}
            </p>
          </div>
        </section>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          className="checkout-view-details-close-btn"
          onClick={handleCloseViewDetails}
        >
          Close
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
}
